import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Button, Icon } from '@pwc/pwc-deals-ui';
import { useTranslation } from 'react-i18next';
import styles from './ModalConfirmation.module.scss';

interface ModalProps {
  show: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  confirmTitle?: string;
  confirmationMessage?: string;
  cancelButtonText?: string;
  confirmButtonText?: string;
}

const ModalConfirmation = ({
  show = false,
  onCancel,
  onConfirm,
  confirmTitle = 'Proceed?',
  confirmationMessage,
  cancelButtonText,
  confirmButtonText = 'Proceed',
}: ModalProps) => {
  const { t } = useTranslation();
  const [buttonPressed, setButtonPressed] = useState(false);

  const handleConfirm = () => {
    onConfirm();
    setButtonPressed(true);
  };

  useEffect(() => {
    setButtonPressed(false);
  }, [show]);

  return (
    <Modal show={show} onHide={onCancel} dialogClassName="actionsFormModalv1">
      <Modal.Header closeButton>
        <Modal.Title>
          <div data-testid="delete-edit-title" className={styles.headerLayout}>
            <div className={styles.icon}>
              <Icon name="alert" className="fill saving-error" width="18" />
            </div>
            <div className={styles.headerText}>{confirmTitle}</div>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.bodyLayout}>
        <div data-testid="delete-edit-body">
          {confirmationMessage || t('areYouSure')}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          icon=""
          iconClasses=""
          className="mr-3 button-outline"
          data-testid="modal-cancel"
          onClick={onCancel}
        >
          {cancelButtonText || t('cancel')}
        </Button>
        <Button
          className=""
          icon=""
          iconClasses=""
          data-testid="modal-confirm"
          onClick={handleConfirm}
          disabled={buttonPressed}
        >
          {confirmButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalConfirmation;
